import React from 'react';

function PoemCard(props) {
  return (
    <div className='poem-card'>
      <p id='poem-message' className="poem-message">
{`Blossoms Among Us
Among us sprouts colorful array,
Like tender buds opening way;
Nestled 'neath sun's dappled gaze,
Two worlds converge – parental phase`}
      </p>
      <p className="poem-signature">
        with love Hugo
      </p>
      <p className="poem-bottom">
        I<i class="fa-solid fa-heart mx-2"></i>WatsonX
      </p>
    </div>
  );
}

export default PoemCard;